import { render, staticRenderFns } from "./drugReport.vue?vue&type=template&id=63fa0902&scoped=true"
import script from "./drugReport.vue?vue&type=script&lang=js"
export * from "./drugReport.vue?vue&type=script&lang=js"
import style0 from "./drugReport.vue?vue&type=style&index=0&id=63fa0902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa0902",
  null
  
)

export default component.exports